import authenticatedRequest from './authenticatedRequest';
import store from './../store';

export default function UsersIntegration(agreementData,currentPage) {
	return class UsersIntegration {
		constructor(editor) {
			this.editor = editor;
		}

		async init() {
			const usersPlugin = this.editor.plugins.get('Users');

			usersPlugin.addUser({
				id: store.state.user.uid,
				name: [store.state.user.displayName, store.state.user.lastName].filter(Boolean).join(' ') || store.state.user.email
			});
			usersPlugin.defineMe(store.state.user.uid);
			const trackedChanges = agreementData.trackedChanges;
			const allComments = agreementData.comments;
			const summaryTrackedChanges = agreementData.summaryTrackedChanges;
			const summaryAllComments = agreementData.summaryComments;

			const fetchAndAddUser = async (userId) => {
				if (!usersPlugin.getUser(userId)) {
					try {
						const response = await authenticatedRequest('GET', `/customer/${userId}`);
						const { user } = response.data;
						if (!usersPlugin.getUser(user.id)) {
							const userDetails = {
								id: user.id,
								name: [user.displayName, user.lastName].filter(Boolean).join(' ') || user.email,
							};
							usersPlugin.addUser(userDetails);
						}
					} catch (error) {
						console.error(
							`Error fetching user with ID ${userId}:`,
							error
						);
					}
				}
			};

			if(currentPage === 'editor'){
				for (const change of trackedChanges) {
					await fetchAndAddUser(change.authorId);
				}
	
				for (const thread of allComments) {
					for (const comment of thread.comments) {
						await fetchAndAddUser(comment.authorId);
					}
				}
			}
			else if(currentPage === 'summary'){
				for (const change of summaryTrackedChanges) {
					await fetchAndAddUser(change.authorId);
				}
	
				for (const thread of summaryAllComments) {
					for (const comment of thread.comments) {
						await fetchAndAddUser(comment.authorId);
					}
				}
			}
		}
	};
}
